module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/6mill-inactive-bb3d1494b2e134d759bac0910d9b1aad.png";